import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { clickButton } from '../../actions/Modal';
import BaseComponent from './BaseComponent';
import Title from '../CommonSet/Title';
import Style from '../../themes/BlueTheme/TextBookLectureProgress.cssmodule.less';
import classNames from 'classnames';

class TextBookLectureProgress extends BaseComponent {
    constructor(props) {
        super(props);
        this.setTheme(props.theme);
        this.status = {
            ready : {
                message: '미학습',
                className: this.Style.ready,
            },
            progress : {
                message: '학습중',
                className: this.Style.progress,
            },
            finished : {
                message: '학습완료',
                className: this.Style.finish,
            }
        }
    }

    setTheme(theme) {
        const themeStyle = this.getTheme(theme, 'TEXTBOOK_LECTURE_PROGRESS');
        this.Style = themeStyle || Style;
    }

    handleButtonClick(event, data) {
        const { clickButton } = this.props.actions;
        clickButton({
            event,
            data
        });
    }

    render() {
        const { name, content = [] } = this.props.item;
        const curriculumList = content.map((item, index) => {
            const { title = '', sequence = '', data = [] } = item;
            const isProgress = data.filter(({status}) => status === 'PROGRESS').length > 0;
            const isFinished = data.filter(({status}) => status !== 'COMPLETED' && status !== 'SUBMITTED').length === 0;
            let status = isProgress ? this.status.progress : this.status.ready;
            if(isFinished) {
                status = this.status.finished;
            }

            return (
                <div key={index} className={this.Style.curriculumList} onClick={() => this.handleButtonClick('select', item)}>
                    <div className={classNames(this.Style.indicator, status.className)}>{status.message}</div>
                    <div className={this.Style.sequence}>{sequence}</div>
                    <div className={this.Style.lectureName}>{title}</div>
                </div>
            );
        });
        return (
            <div className={this.Style.textbookLectureProgress}>
                <Title
                    className={this.Style.title}
                    isClose
                    onClose={() => this.handleButtonClick('close')}
                >
                    {this.props.item.title}
                </Title>

                <div className={this.Style.contentView}>
                    <div className={this.Style.footNote}>
                        <div className={this.Style.curriculum_title}>{name}</div>
                    </div>
                    <div className={this.Style.content}>
                        <div className={this.Style.curriculumListView}>{curriculumList}</div>
                    </div>
                </div>
            </div>
        );
    }
}

TextBookLectureProgress.displayName = 'TextBookLectureProgress';
TextBookLectureProgress.propTypes = {};

function mapDispatchToProps(dispatch) {
    const actions = { clickButton };
    const actionMap = { actions: bindActionCreators(actions, dispatch) };
    return actionMap;
}

export default connect(
    undefined,
    mapDispatchToProps
)(TextBookLectureProgress);



// WEBPACK FOOTER //
// ./components/ModalSet/TextBookLectureProgress.js